import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-wrapper flex flex--v flex--valign-c flex--gap-60" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchCompany = _resolveComponent("SearchCompany")
  const _component_CompaniesList = _resolveComponent("CompaniesList")
  const _component_PaginationNew = _resolveComponent("PaginationNew")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.companies.data === false)
      ? (_openBlock(), _createBlock(_component_SearchCompany, {
          key: 0,
          ref: "startOfJobfuchs",
          "searching-process": _ctx.searchingProcess,
          "economic-sectors": _ctx.economicSectors,
          "search-string": _ctx.searchStr,
          onChangeInputValue: _cache[1] || (_cache[1] = (val) => (_ctx.searchStr = val)),
          onClickSearchCompany: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search()))
        }, null, 8, ["searching-process", "economic-sectors", "search-string"]))
      : (_openBlock(), _createBlock(_component_CompaniesList, {
          key: 1,
          "qualification-input": _ctx.qualificationInput,
          "qualification-groups": _ctx.qualificationGroups,
          companies: _ctx.companies.data,
          "no-companies": _ctx.noCompanies,
          "detail-view-company-id": _ctx.detailViewCompanyId,
          onClickBackToSearch: _ctx.resetSearch,
          onChangeDetailViewCompanyId: _ctx.changeDetailViewCompanyId
        }, null, 8, ["qualification-input", "qualification-groups", "companies", "no-companies", "detail-view-company-id", "onClickBackToSearch", "onChangeDetailViewCompanyId"])),
    (_ctx.companies.data !== false && _ctx.companies.last_page > 1 && !_ctx.detailViewCompanyId)
      ? (_openBlock(), _createBlock(_component_PaginationNew, {
          key: 2,
          "pagination-data": _ctx.companies,
          class: "pagination-new",
          onPaginate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search($event, true)))
        }, null, 8, ["pagination-data"]))
      : _createCommentVNode("", true)
  ]))
}